import React, {Component} from 'react'
import {Bar, Pie} from 'react-chartjs-2'
import {bindActionCreators} from "redux"
import {withStyles} from "@material-ui/core/styles"
import {withRouter} from "react-router-dom"
import {connect} from "react-redux"

class SurveyChart extends Component {

    render() {
        const {surveyCount} = this.props

        const colors = {
            backgroundColor: [
                '#FFB5B5',
                '#FFD9EC',
                '#FFD0FF',
                '#E6CAFF',
                '#F0F0F0',
            ],
            hoverBackgroundColor: [
                '#FF2D2D',
                '#FF79BC',
                '#FF77FF',
                '#BE77FF',
                '#ADADAD',
            ],
        }

        const data = {
            careers: {
                count: {
                    agricultural: 0, fishery: 0, forestry: 0, mining: 0,
                    hospitality: 0, architects: 0, manufacturing: 0, news: 0,
                    health: 0, recreation: 0, education: 0, religious: 0,
                    public: 0, service: 0, housekeeper: 0, information: 0,
                    security: 0, army: 0, sports: 0, other: 0,
                },
                list: {
                    agricultural: '農牧業', fishery: '漁業', forestry: '木材森林業', mining: '礦業採石業',
                    hospitality: '餐旅業', architects: '建築工程業', manufacturing: '製造業', news: '新聞廣告業',
                    health: '衛生保健', recreation: '娛樂業', education: '文教機關', religious: '宗教團體',
                    public: '公共事業', service: '服務業', housekeeper: '家庭管理', information: '資訊業',
                    security: '治安人員', army: '軍人', sports: '運動人員', other: '其他',
                },
            },
            usageCount: {
                count: {
                    '1': 0, '2': 0, '3': 0, '4': 0,
                },
                list: {
                    '1': '1 次', '2': '2 次', '3': '3 次', '4': '3 次以上',
                },
            },
            other: {
                list: {
                    medicalProfessional: '醫師專業度', medicalSolved: '問題解決度',
                    flowSatisfied: '視訊品質', platformKeepUsing: '持續使用率',
                    platformSatisfied: '整體滿意度',
                }
            },
            medicalProfessional: 0,
            medicalSolved: 0,
            flowSatisfied: 0,
            platformKeepUsing: 0,
            platformSatisfied: 0,

        }

        surveyCount.forEach(el => {
            const {
                career,
                usageCount,
                medicalProfessional,
                medicalSolved,
                flowSatisfied,
                platformKeepUsing,
                platformSatisfied,
            } = el
            ++data.careers.count[career]
            ++data.usageCount.count[usageCount]
            data.medicalProfessional += parseInt(medicalProfessional, 10)
            data.medicalSolved += parseInt(medicalSolved, 10)
            data.flowSatisfied += parseInt(flowSatisfied, 10)
            data.platformKeepUsing += parseInt(platformKeepUsing, 10)
            data.platformSatisfied += parseInt(platformSatisfied, 10)
        })

        if (surveyCount.length) {
            data.medicalProfessional /= surveyCount.length
            data.medicalSolved /= surveyCount.length
            data.flowSatisfied /= surveyCount.length
            data.platformKeepUsing /= surveyCount.length
            data.platformSatisfied /= surveyCount.length
        }

        return (
            <div>
                <Pie
                    data={{
                        labels: Object.values(data.careers.list),
                        datasets: [
                            {
                                label: 'career',
                                data: Object.values(data.careers.count),
                                backgroundColor: [
                                    ...colors.backgroundColor,
                                    ...colors.backgroundColor,
                                    ...colors.backgroundColor,
                                    ...colors.backgroundColor,
                                ],
                                hoverBackgroundColor: [
                                    ...colors.hoverBackgroundColor,
                                    ...colors.hoverBackgroundColor,
                                    ...colors.hoverBackgroundColor,
                                    ...colors.hoverBackgroundColor,
                                ],
                            }
                        ],
                    }}
                    options={{
                        title: {
                            display: true,
                            text: '職業',
                            fontSize: 25,
                        },
                        legend: {
                            display: true,
                            position: 'right',
                        },
                    }}
                />
                <br/>
                <Pie
                    data={{
                        labels: Object.values(data.usageCount.list),
                        datasets: [
                            {
                                label: 'usageCount',
                                data: Object.values(data.usageCount.count),
                                backgroundColor: colors.backgroundColor,
                                hoverBackgroundColor: colors.hoverBackgroundColor,
                            }
                        ],
                    }}
                    options={{
                        title: {
                            display: true,
                            text: '已使用次數',
                            fontSize: 25,
                        },
                        legend: {
                            display: true,
                            position: 'right',
                        },
                    }}
                />
                <br/>
                <Bar
                    data={{
                        labels: Object.values(data.other.list),
                        datasets: [
                            {
                                label: '',
                                data: [
                                    data.medicalProfessional,
                                    data.medicalSolved,
                                    data.flowSatisfied,
                                    data.platformKeepUsing,
                                    data.platformSatisfied,
                                ],
                                backgroundColor: colors.backgroundColor,
                                hoverBackgroundColor: colors.hoverBackgroundColor,
                            }
                        ],
                    }}
                    options={{
                        title: {
                            display: true,
                            text: '其他項目',
                            fontSize: 25,
                        },
                        legend: {
                            display: false,
                        },
                        scales: {
                            yAxes: [{
                                ticks: {
                                    max: 5,
                                    min: 0,
                                }
                            }]
                        }
                    }}
                />
            </div>
        )
    }
}

const styles = theme => ({
    root: {},
    labels: {},
    tooltip: {
        maxWidth: 100,
    }
})

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}

function mapStateToProps() {
    return {}
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(SurveyChart)))



// WEBPACK FOOTER //
// ./src/main/content/callHelper/surveyCount/SurveyChart.js